/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPork = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.603 16.813a6.101 6.101 0 0 0 5.818-1.6l3.848-3.847c.908-.909.828-2.264.467-3.36-.382-1.16-1.176-2.397-2.26-3.481s-2.322-1.879-3.482-2.26c-1.096-.361-2.45-.441-3.359.467L8.788 6.58A6.102 6.102 0 0 0 7.2 12.447c-.21.218-.416.436-.618.654a3.436 3.436 0 0 0-3.574 5.671c.405.406.889.69 1.402.85a3.437 3.437 0 1 0 6.522-2.173c.223-.207.447-.419.672-.636zm-1.966-.892-.068.063a2 2 0 0 0-.525 2.13 1.437 1.437 0 1 1-2.726.911 2 2 0 0 0-1.312-1.311 1.437 1.437 0 1 1 .91-2.727 2 2 0 0 0 2.189-.587 6.127 6.127 0 0 0 1.532 1.521zm7.813-9.37c-.494-.494-1.097-.691-1.344-.445-.247.247-.047.848.447 1.341.493.494 1.094.694 1.34.447.247-.247.05-.85-.444-1.344zm-3.4-2.404c.088-.088.45-.269 1.319.017.806.265 1.783.866 2.692 1.775.91.91 1.51 1.887 1.775 2.693.287.87.106 1.232.018 1.32-.087.086-.444.266-1.31-.023-.803-.268-1.779-.871-2.69-1.782-.91-.911-1.514-1.887-1.782-2.69-.289-.867-.109-1.224-.022-1.31zm3.862 7.68.05.016-1.955 1.955a4.105 4.105 0 1 1-5.805-5.805l1.956-1.955.017.051c.385 1.156 1.182 2.39 2.265 3.472 1.083 1.083 2.316 1.88 3.472 2.265z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPork as Pork };
